import { useAsiAllowedByOrganization } from '#pplx/frontend/apps/ask/organization/hooks/useAsiAllowedByOrganization.js';
import { useBrowserAgentDisabledByOrg } from '#pplx/frontend/apps/ask/organization/hooks/useBrowserAgentDisabledByOrg.js';
import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import { useCallback } from 'react';
export function useIsModeDisabledByOrg() {
    const isBrowserAgentDisabledByOrg = useBrowserAgentDisabledByOrg();
    const asiAllowedByOrg = useAsiAllowedByOrganization();
    return useCallback((mode) => {
        switch (mode) {
            case SearchMode.BROWSER_AGENT:
                return isBrowserAgentDisabledByOrg;
            case SearchMode.ASI:
                return !asiAllowedByOrg;
            default:
                return false;
        }
    }, [isBrowserAgentDisabledByOrg, asiAllowedByOrg]);
}
//# sourceMappingURL=useIsModeDisabledByOrg.js.map